export const EVIDENCE_COLLECTION = "evidence";
export const IAM_ASSESSMENTS_COLLECTION = "iam-assessments";
export const IDENTITY_GRAPH_COLLECTION = "identity-graph";
export const PERMISSION_REQUESTS_COLLECTION = "permission-requests";
